import cookies from 'js-cookie'
// SDK产品信息
const SDK_PRODUCT = {
  id: 13,
  key: 'ca41346e78d6f11bfcfebc72463c8d2e',
  version: 1 // sdk版本号
}

const PAGE_NUM = {
  Home: 0,
  PdfHome: 1,
  AdCharge: 26,
  CompRedbag: 67, // 红包活动
  LifelongVipDiscount: 68, // 终身VIP活动
  OfficialAccounts: 2, // 公众号支付
  Translate: 3 // 全文翻译会员中心
}

const STAY_PAGE_NUM = {
  Home: 1,
  videoHome: 2, // 视频转换器首页
  Translate: 3 // 全文翻译
}
// 特权独立支付页 对应上报值
export const PERMISSION_REPORT = {
  data_recovery: 1,
  photo_recovery: 3,
  sj_recovery: 2,
  pdf_to_word: 4,
  popwindow_block: 6, // 软件净化，5是旧版页面的值
  privacy_clean: 7,
  file_shred: 8,
  system_slim: 9
}
// 上报相关
const REPORT_PARAMS = {
  show_from: cookies.get('show_from') || 0,
  main_from: cookies.get('show_from') || 0,
  vip_version: cookies.get('vip_version') || 0,
  enter_time: cookies.get('enter_time') || '',
  user_svrid: cookies.get('svrid') || '',
  report_version: 5
}
// 域名相关
const DOMAIN_RELATED = {
  domain: `${location.protocol}//${location.host}/`,
  channel: location.pathname.split('/')[1]
}
// 登录服务相关
const LOGIN_SERVICE = {
  url: `${location.protocol}//viplogin.ijinshan.com/1335/login`
}

// 微信AppId
const WXJSDK_APPID = 'wx6a49191e9691b35c'
// 搜狗微信APPID
const SOUGOU_WXJSDK_APPID = 'wx5d45a77e38b8adf1'

/** 支付模块和二维码曝光监控 */
const REPORT_RELATED = {
  /** 1-点击套餐；2-勾选签约；3-取消勾选签约；4-点击“微信套餐”；5-点击“支付宝套餐” */
  action: {
    package_click: 1,
    tick_renewal: 2,
    uncheck_renewa: 3,
    choose_weChat_pay: 4,
    choose_alipay: 5
  },
  /** 1-“请点击刷新（未登录)”；2-支付二维码；3-游客二维码；4-“请点击刷新（二维码过期)” */
  qr_type: {
    login: 1,
    pay: 2,
    tourist: 3,
    expire: 4
  },
  /** 二维码展示：1-展示成功；2-展示-失败 */
  qr_show: {
    success: 1,
    fail: 2,
    api_begin: 3,
    api_success: 4,
  }
}

/** 服务端用于区分PDF套餐 与 毒霸联合会员套餐 */
const UNI_FROM = {
  /** 极光PDF权益套餐 */
  PDF_PAY: 1,
  /** 毒霸联合会员套餐 */
  PDF_DUBA_PAY: 2
}

/** 本地存储 滚动位置 */
const LOCALSTORAGE_POSITION_KEY = 'vip_scroll_position'
/** 本地存储 支付模块高度 */
const LOCALSTORAGE_PAY_HEIGHT_KEY = 'vip_pay_height'

const REGISTER_FRM = {
  0: '未知',
  1: '微信',
  2: 'QQ',
  3: '手机',
  90: '老会员'
}

/** 用户协议 */
const PRIVACYLINK = 'https://www.ijinshan.com/privacy/PDF-License-sg.html'

/** 隐私协议 */
const PRIVACY_POLICY = 'https://www.kingpdf.cn/privacy/PDF-Privacy-20231213.html'

/** 订阅协议 */
const SUBSCRIPTION_POLICY = 'https://rule.tencent.com/rule/202403020001'

const pathname = location.pathname.split('/')[1]
const isPrerender = window.__PRERENDER_INJECTED__ === 'prerender'
/* global buildChannel */

const url = isPrerender ? `http://pdfvip.ijinshan.com/${buildChannel}` : `${window.location.origin}/${pathname}`
// TODO: 极光PDF暂未接入自己的QQ登录，所以使用sdk的qq登录
const qqUrl = 'http://viplogin.ijinshan.com/1335'

// 搜狗在线开票url
const SOGOU_INVOICE_URL = 'https://wj.qq.com/s2/14591955/6821/'

const URL_LIST = {
  login: url + '/login/',
  wechat: url + '/auth/3?jump=1',
  // qq: qqUrl + '/auth/4?jump=1'
  qq: url + '/auth/4?jump=1'
}

/** 上报登录类型 */
const REPORT_LOGIN_TYPE = {
  /** 手机  */
  phone: 1,
  /** 微信授权 */
  wechat: 2,
  /** qq登录 */
  qq: 3,
  /** 一键登录 */
  quickLogin: 5,
  /** 关注公众号登录 */
  officialAccount: 7,
  /** AB测-公众号登录 */
  abTestOfficialAccount: 7,
  /** AB测-微信授权登录 */
  abTestWechat: 8
}

const PERMISSION_VIP_TYPE = {
  /** pdf会员 */
  member: 2,
  /** pdf终身会员 */
  lifeMember: 3,
  /** 视频会员 */
  videoVip: 101,
  /** 视频终身会员 */
  videoLifeMember: 102,
  /** 极光pdf超级会员 */
  pdfSVip: 199,
  /** 极光pdf超级终身会员 */
  pdfSuperLifeMember: 200
}

const DUBA_VIP_TYPE = {
  /** 非会员 */
  nonmember: 0,
  /** 普通会员 */
  normalMember: 2,
  /** 超级会员 */
  superMember: 5,
  /** 钻石会员 */
  diamondMember: 3
}

const OCPC_CONVERT_TYPE = {
  INSTALL: 1,
  LOGIN: 2,
  BUY: 3,
  STAY: 4
}

// 客服链接 - 3068搜狗专属
const CUSTOMER_SERVICE_LINK = 'https://wpa1.qq.com/LTQUvZ7j?_type=wpa&qidian=true'

// 支付渠道
const PAY_CHANNEL = {
  WECHAT: 1, // 微信
  ALIPAY: 2, // 支付宝
  LENOVO: 4, // 联想支付
  SOGOU: 5, // 搜狗支付
}

// 支付方式
const PAY_TYPE = {
  WX_WEB: 'wx_web', // 微信内调起 jsapi 支付
  WX_QRCODE: 'wx_qrcode', // 微信二维码支付
  ALIPAY_QRCODE: 'alipay_qrcode', // 支付宝二维码支付
  WX_APP: 'wx_app', // 微信应用支付
  ALIPAY_APP: 'alipay_app', // 支付宝移动支付
  LENOVO_PAY: 'lenovo_pay', // 联想支付
  SOGOU_WX_QRCODE: 'sougou_wx_qrcode', // 搜狗的微信二维码支付
  SOGOU_WX_WEB: 'sougou_wx_web', // 微信内调起 jsapi 支付
}

// 搜狗PDF用户评论AB测ab方案名列表
const AB_LIST = {
  COMMENT_AB_LIST: ['sougou_userfeedback'],
  PAY_AB_LIST: ['pdf_payment_middleware_switch_3068'], // 支付中间页AB测配置
  UNFINISH_PAY_AB_LIST: ['unfinish_pay_popup_sogou_3068'], // 未支付引导页AB测配置
}

const UNFINISH_PAY_LIST = {
  INIT_STATUS: 0, // 初始化状态
  HAVE_SCAN_QRCODE: 1, // 已经扫描支付二维码
  HAVE_OPEN_UNFINISH_MODULE: 2, // 已经打开未支付引导模块
}

export {
  SDK_PRODUCT,
  PAGE_NUM,
  STAY_PAGE_NUM,
  REPORT_PARAMS,
  DOMAIN_RELATED,
  LOGIN_SERVICE,
  REPORT_RELATED,
  UNI_FROM,
  LOCALSTORAGE_POSITION_KEY,
  LOCALSTORAGE_PAY_HEIGHT_KEY,
  URL_LIST,
  REPORT_LOGIN_TYPE,
  REGISTER_FRM,
  PRIVACYLINK,
  PERMISSION_VIP_TYPE,
  DUBA_VIP_TYPE,
  WXJSDK_APPID,
  OCPC_CONVERT_TYPE,
  CUSTOMER_SERVICE_LINK,
  PAY_CHANNEL,
  PAY_TYPE,
  PRIVACY_POLICY,
  SUBSCRIPTION_POLICY,
  SOGOU_INVOICE_URL,
  AB_LIST,
  SOUGOU_WXJSDK_APPID,
  UNFINISH_PAY_LIST
}
